import { cva, type VariantProps } from 'class-variance-authority'
import React from 'react'
import { collectionGradients } from '@/app/baza/_utils/gradients'
import { cn } from '@/frontend/utils'

const textDecoratorVariants = cva('', {
  variants: {
    variant: {
      algosecondary: 'text-algosecondary font-semibold',
      algoprimary: 'text-algoprimary font-semibold',
      gradient:
        'text-bold bg-gradient-to-br from-algoprimary to-algosecondary bg-clip-text text-transparent',
      ...collectionGradients
    }
  }
})

type TextDecoratorVariants = VariantProps<typeof textDecoratorVariants>

type TextDecoratorProps = TextDecoratorVariants & {
  children: React.ReactNode
  gradientColor?: string
}

export const TextDecorator = React.forwardRef<HTMLSpanElement, TextDecoratorProps>(
  ({ variant, gradientColor, ...props }, ref) => {
    return (
      <span
        className={cn(
          textDecoratorVariants({ variant }),
          gradientColor && 'bg-gradient-to-r bg-clip-text text-bold text-transparent',
          gradientColor
        )}
        ref={ref}
        {...props}
      >
        {props.children}
      </span>
    )
  }
)
TextDecorator.displayName = 'TextDecorator'
